import DescriptionList from 'ant-design-pro/lib/DescriptionList';
import Description from 'ant-design-pro/lib/DescriptionList/Description';
import PageHeader from 'ant-design-pro/lib/PageHeader';
import { Breadcrumb, Empty } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Link, Route, Switch } from 'react-router-dom';

import { LessonStatus, UserData } from './Enrollment';
import { EnrollmentReport } from './EnrollmentReport';
import { LessonDetail } from './LessonDetail';

interface Props {
  match: any;
}

export const userEnrollmentsQuery = gql`
  query getUserEnrollments($ids: [ID], $enrollmentIds: [Int]) {
    users(ids: $ids) {
      enrollments(ids: $enrollmentIds) {
        id
        sku {
          id
          name
          course {
            id
            name
          }
          start
          end
        }
        learnOverview {
          learnDayCount
          learnDuration
          knowledgePointCount
        }
        scheduleProgress {
          unlockCount
          onTimeCount
          makeUpCount
          makeUpLessons {
            displayId
            serialId
          }
          missedLessons {
            displayId
            serialId
          }
        }
        sku {
          id
          course {
            id
            lessons {
              id
              name
            }
            teachingPoints {
              id
              name
              type
            }
          }
        }
        lessonProgresses {
          serialId
          unlockAt
          status
          lesson {
            id
            name
          }
          evaluations {
            id
          }
        }
      }
    }
  }
`;

interface EnrollmentStates {
  id?: number;
  enrollmentId?: number;
  serialId?: number;
}

export class EnrollmentDetail extends Component<Props, EnrollmentStates> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { id: userId, enrollmentId } = this.props.match.params;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/user/${userId}`}>用户详情</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>学习报告详情</Breadcrumb.Item>
        </Breadcrumb>
        <Query<UserData> query={userEnrollmentsQuery} variables={{ ids: [userId], enrollmentIds: [enrollmentId] }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const [user] = (data && data.users) || [null];

            const [enrollment] = user && user.enrollments;

            const tabList = [
              {
                key: 'lesson',
                tab: <Link to={`/user/${userId}/enrollment/${enrollment.id}/lesson`}>课时情况</Link>,
              },
              {
                key: 'report',
                tab: <Link to={`/user/${userId}/enrollment/${enrollment.id}/report`}>话术反馈</Link>,
              },
            ];
            return (
              <>
                <PageHeader
                  title={enrollment && enrollment.sku.name}
                  content={
                    enrollment && (
                      <>
                        <DescriptionList size="small" title="学习预览">
                          <Description term="累计学习天数">{enrollment.learnOverview.learnDayCount}</Description>
                          <Description term="累计学习课时">
                            {
                              enrollment.lessonProgresses.filter(
                                lessonProgress => lessonProgress.status === LessonStatus.PLAYED,
                              ).length
                            }
                          </Description>
                          <Description term="累计学习时间">{enrollment.learnOverview.learnDuration}</Description>
                          <Description term="累计攻克知识点">
                            {enrollment.learnOverview.knowledgePointCount}
                            /77
                          </Description>
                        </DescriptionList>
                        <DescriptionList size="small" title="学习进度" style={{ marginTop: 20 }}>
                          <Description term="已解锁课程数">{enrollment.scheduleProgress.unlockCount}</Description>
                          <Description term="按时上课数">{enrollment.scheduleProgress.onTimeCount}</Description>
                          <Description term="已补课程数">{enrollment.scheduleProgress.makeUpCount}</Description>
                          <Description term="已补课程">
                            {enrollment.scheduleProgress.makeUpLessons
                              .map(lesson => lesson.displayId || lesson.serialId)
                              .join()}
                          </Description>
                        </DescriptionList>
                      </>
                    )
                  }
                  tabList={tabList}
                  tabActiveKey={/lesson/g.test(window.location.href) ? 'lesson' : 'report'}
                />
                <Switch>
                  <Route exact path={`${this.props.match.url}/report`}>
                    <EnrollmentReport
                      userId={userId}
                      enrollmentId={enrollmentId}
                      lessons={enrollment.sku.course.lessons}
                      teachingPoints={enrollment.sku.course.teachingPoints}
                    />
                  </Route>
                  <Route exact path={`${this.props.match.url}/lesson`}>
                    <LessonDetail enrollment={enrollment} loading={loading} userId={userId} />
                  </Route>
                </Switch>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/enrollment/EnrollmentDetail.tsx